import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

/**
 * Pie de página compartido por `PublicLayout` y `CompanyLayout`: copyright +
 * enlaces a Privacidad y Términos. `sticky bottom-0` en vez de `fixed`: se
 * queda siempre visible mientras se hace scroll, pero acotado al ancho de la
 * columna de contenido (no del viewport completo), así nunca tapa el
 * sidebar oscuro que vive al lado.
 */
export default function AppFooter() {
  const { t } = useTranslation()

  return (
    <footer className="sticky bottom-0 z-30 border-t border-ink-100 bg-(--humania-surface) backdrop-blur">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-1 px-4 py-2 text-center sm:flex-row sm:justify-between sm:gap-3 sm:px-6 sm:text-left">
        <p className="text-xs text-ink-400">
          {t('marketing.copyright', { year: new Date().getFullYear() })}
        </p>
        <nav
          aria-label={t('marketing.footerNav')}
          className="flex flex-wrap items-center justify-center gap-4 text-xs text-ink-500"
        >
          <Link to="/legal/privacidad" className="hover:text-brand-600 hover:underline">
            {t('legal.privacyTitle')}
          </Link>
          <Link to="/legal/terminos" className="hover:text-brand-600 hover:underline">
            {t('legal.termsTitle')}
          </Link>
        </nav>
      </div>
    </footer>
  )
}
